// import { border, height, minHeight } from "@mui/system";

const styles = {
    container: {
        paddingTop: 10,
        mb: 5,
        // '@media (min-width:600px)': {
        //     marginTop: '2%',
        // },
        // '@media (min-width:960px)': {
        //     marginTop: '2%',
        // },
        // '@media (min-width:1280px)': {
        //     marginTop: '2%',
        // },
    },
    heading: {
        fontFamily: 'Inter',
        fontSize: 42,
        fontWeight: 600,
        color: '#000000',
        textAlign: 'center',
    },
    subHeading: {
        fontFamily: 'Poppins, Arial, sans-serif',
        fontSize: '16px',
        fontWeight: 600,
        color: '#000000',
        textAlign: 'center',
    },
    divider: {
        width: '80%',
        // height: '2px',
        border: '2px solid black',
        marginBottom: 9,
        textAlign: 'center',
        margin: '0 auto',
        mt: "2px",
    },
    sliderContainer: {
        position: 'relative',
        width: '100%',
        mx: 0,  
        p: 0,       
        // marginTop: '7%',
    },
    leftIcon: {
        position: 'absolute',
        top: '50%',
        left: '20px',
        transform: 'translateY(-50%)',
        zIndex: 5,
        // backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: 'black',
        // '&:hover': {
        //     backgroundColor: 'rgba(0, 0, 0, 0.7)',
        // },
    },
    rightIcon: {
        position: 'absolute',
        top: '50%',
        right: '20px',
        transform: 'translateY(-50%)',
        zIndex: 10,
        // backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: '#333333',
        // '&:hover': {
        //     backgroundColor: 'rgba(0, 0, 0, 0.7)',
        // },
    },
    thumbnailStrip: {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        mt: 2,
        "&::-webkit-scrollbar": {
            display: "none",
        },
        scrollbarWidth: "none",
    },
    thumbnail: (isActive) => ({
        cursor: "pointer",
        border: isActive ? "2px solid black" : "2px solid transparent",
        mx: { xs: '3px', sm: '4px', md: '7', lg: '7px' },
        width: { xs: '30%', sm: '30%', md: '30%', lg: '24%' },
        height: { xs: '50px', sm: '60px', md: '140px', lg: '147px' },
        // overflow: "hidden",
        flex: "0 0 auto",
    }),
    thumbnailImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    iconOverlay: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        color: "#333333",
        fontSize: "50px", // Adjust the icon size if necessary
        opacity: 0.8,
        pointerEvents: "none", // Ensure clicks pass through the icon to the thumbnail
    },    
    dotsAndNavigation: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mt: 2,
        position: "relative",
        width: "100%",
        height: "50px",
    },
    dotContainer: {
        display: "flex",
        overflowX: "hidden",
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1,
        width: "60%",
    },
    dot: (isActive) => ({
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        backgroundColor: isActive ? "#0D8B5A" : "lightgray",
        mx: 1,
        cursor: "pointer",
    }),
};

export default styles;
